module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keyword_filter":"Exclude","add_keyword":"Exclude keyword"},"fr":{"keyword_filter":"Exclure","add_keyword":"Exclure mot clé"},"de":{"keyword_filter":"Ausschließen","add_keyword":"Stichwort ausschließen"}}')
  delete Component.options._Ctor
}
